// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasePopup-module__font-s-10___z6vHk {
  font-size: 10px !important;
}

.BasePopup-module__font-s-12___AECVr {
  font-size: 12px !important;
}

.BasePopup-module__font-s-13___jD4Xc {
  font-size: 13px !important;
}

.BasePopup-module__font-s-14___uYASq {
  font-size: 14px !important;
}

.BasePopup-module__font-s-15___o_hF6 {
  font-size: 15px !important;
}

.BasePopup-module__font-s-16___Y6dAM {
  font-size: 16px !important;
}

.BasePopup-module__font-s-18___EzuRL {
  font-size: 18px !important;
}

.BasePopup-module__font-s-20___szNU4 {
  font-size: 20px !important;
}

.BasePopup-module__font-s-22____UxZT {
  font-size: 22px !important;
}

.BasePopup-module__font-s-28___m8Zbj {
  font-size: 28px !important;
}

.BasePopup-module__font-w-400___K7Xox {
  font-weight: 400 !important;
}

.BasePopup-module__font-w-500___xJAwv {
  font-weight: 500 !important;
}

.BasePopup-module__font-w-600___ug90o {
  font-weight: 600 !important;
}

.BasePopup-module__font-w-700___sT_T1 {
  font-weight: 700 !important;
}

.BasePopup-module__p-5___jt0Hh {
  padding: 5px !important;
}

.BasePopup-module__p-12___FLkgo {
  padding: 12px !important;
}

.BasePopup-module__p-16___o3nkw {
  padding: 16px !important;
}

.BasePopup-module__p-30___XHbQR {
  padding: 30px !important;
}

.BasePopup-module__p-b-0___iINuq {
  padding-bottom: 0 !important;
}

.BasePopup-module__p-b-5___Ul_C_ {
  padding-bottom: 5px !important;
}

.BasePopup-module__p-b-10___zXuAM {
  padding-bottom: 10px !important;
}

.BasePopup-module__p-b-12___fuH9l {
  padding-bottom: 12px !important;
}

.BasePopup-module__p-b-16___KR4YZ {
  padding-bottom: 16px !important;
}

.BasePopup-module__p-b-18____Y3lu {
  padding-bottom: 18px !important;
}

.BasePopup-module__p-b-20___RGy7_ {
  padding-bottom: 20px !important;
}

.BasePopup-module__p-b-25___PhhJM {
  padding-bottom: 25px !important;
}

.BasePopup-module__p-b-30___NQk7g {
  padding-bottom: 30px !important;
}

.BasePopup-module__p-b-50___SJ65S {
  padding-bottom: 50px !important;
}

.BasePopup-module__p-t-0___sfizd {
  padding-top: 0 !important;
}

.BasePopup-module__p-t-12___jvOgT {
  padding-top: 12px !important;
}

.BasePopup-module__p-t-16___WMsKd {
  padding-top: 16px !important;
}

.BasePopup-module__p-t-18___kp4V4 {
  padding-top: 18px !important;
}

.BasePopup-module__p-t-20___yqekv {
  padding-top: 20px !important;
}

.BasePopup-module__p-t-30___Va2_j {
  padding-top: 30px !important;
}

.BasePopup-module__p-t-40___OHpaF {
  padding-top: 40px !important;
}

.BasePopup-module__p-t-50___ySCrN {
  padding-top: 50px !important;
}

.BasePopup-module__p-l-20___I4MmB {
  padding-left: 20px !important;
}

.BasePopup-module__p-l-30___wAPrD {
  padding-left: 30px !important;
}

.BasePopup-module__p-l-40___tCBaV {
  padding-left: 40px !important;
}

.BasePopup-module__p-r-16___S_QWH {
  padding-right: 16px !important;
}

.BasePopup-module__p-r-20___kgrIe {
  padding-right: 20px !important;
}

.BasePopup-module__p-r-30___c379q {
  padding-right: 30px !important;
}

.BasePopup-module__p-r-50___p8_9x {
  padding-right: 50px !important;
}

.BasePopup-module__p-r-60___Xv88m {
  padding-right: 60px !important;
}

.BasePopup-module__m-b-1___bQVcg {
  margin-bottom: 1px !important;
}

.BasePopup-module__m-b-2___Xoyf7 {
  margin-bottom: 2px !important;
}

.BasePopup-module__m-b-6___EWEqD {
  margin-bottom: 6px !important;
}

.BasePopup-module__m-b-8___L7BpU {
  margin-bottom: 8px !important;
}

.BasePopup-module__m-b-10___cnGmf {
  margin-bottom: 10px !important;
}

.BasePopup-module__m-b-14___z6rEl {
  margin-bottom: 14px !important;
}

.BasePopup-module__m-b-16___bJxG3 {
  margin-bottom: 16px !important;
}

.BasePopup-module__m-b-20___lXHsS {
  margin-bottom: 20px !important;
}

.BasePopup-module__m-b-22___iGZfV {
  margin-bottom: 22px !important;
}

.BasePopup-module__m-b-24___tA6tv {
  margin-bottom: 24px !important;
}

.BasePopup-module__m-b-30___U7U5O {
  margin-bottom: 30px !important;
}

.BasePopup-module__m-b-32___p3E31 {
  margin-bottom: 32px !important;
}

.BasePopup-module__m-b-40___j2ZRF {
  margin-bottom: 40px !important;
}

.BasePopup-module__m-t-2___g2R2g {
  margin-top: 2px !important;
}

.BasePopup-module__m-t-3___QePtk {
  margin-top: 3px !important;
}

.BasePopup-module__m-t-4___qHfSO {
  margin-top: 4px !important;
}

.BasePopup-module__m-t-5___rbDcF {
  margin-top: 5px !important;
}

.BasePopup-module__m-t-8___rhwtV {
  margin-top: 8px !important;
}

.BasePopup-module__m-t-10___EWRzH {
  margin-top: 10px !important;
}

.BasePopup-module__m-t-15___VT30O {
  margin-top: 15px !important;
}

.BasePopup-module__m-t-16____VimJ {
  margin-top: 16px !important;
}

.BasePopup-module__m-t-20___atkAu {
  margin-top: 20px !important;
}

.BasePopup-module__m-t-22___NU_Pp {
  margin-top: 22px !important;
}

.BasePopup-module__m-t-30___lnqbS {
  margin-top: 30px !important;
}

.BasePopup-module__m-t-32___INfLx {
  margin-top: 32px !important;
}

.BasePopup-module__m-l-auto___hyG6t {
  margin-left: auto !important;
}

.BasePopup-module__m-l-4___uiJe3 {
  margin-left: 4px !important;
}

.BasePopup-module__m-l-5___K2sDK {
  margin-left: 5px !important;
}

.BasePopup-module__m-l-6___Q4s1K {
  margin-left: 6px !important;
}

.BasePopup-module__m-l-8___R18X2 {
  margin-left: 8px !important;
}

.BasePopup-module__m-l-10___G4qvA {
  margin-left: 10px !important;
}

.BasePopup-module__m-l-16___J7YGB {
  margin-left: 16px !important;
}

.BasePopup-module__m-l-20____8erd {
  margin-left: 20px !important;
}

.BasePopup-module__m-l-24___vIuRW {
  margin-left: 24px !important;
}

.BasePopup-module__m-l-30___bM5wq {
  margin-left: 30px !important;
}

.BasePopup-module__m-l-35___mOT8J {
  margin-left: 35px !important;
}

.BasePopup-module__m-l-40___qPepu {
  margin-left: 40px !important;
}

.BasePopup-module__m-r-8___mJ95N {
  margin-right: 8px !important;
}

.BasePopup-module__m-r-10___Ewj91 {
  margin-right: 10px !important;
}

.BasePopup-module__m-r-16___EWai_ {
  margin-right: 16px !important;
}

.BasePopup-module__m-r-20___Kolph {
  margin-right: 20px !important;
}

.BasePopup-module__m-r-24___Ki0gN {
  margin-right: 24px !important;
}

.BasePopup-module__m-r-30___orBcb {
  margin-right: 30px !important;
}

.BasePopup-module__m-r-40___nvK7V {
  margin-right: 40px !important;
}

.BasePopup-module__border-r-3___uXoxK {
  border-radius: 3px !important;
}

.BasePopup-module__border-r-4___eNf1X {
  border-radius: 4px !important;
}

.BasePopup-module__border-r-6___vasEC {
  border-radius: 6px !important;
}

.BasePopup-module__border-r-10___I9cAv {
  border-radius: 10px !important;
}

.BasePopup-module__border-r-12___PAJLb {
  border-radius: 12px !important;
}

.BasePopup-module__border-r-16___siVbK {
  border-radius: 16px !important;
}

.BasePopup-module__border-r-50___crWkF {
  border-radius: 50% !important;
}

.BasePopup-module__primary-border___MLeVz {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BasePopup-module__primary-border-b___BytEe {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BasePopup-module__primary-border-t___iuZjx {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BasePopup-module__primary-border-l___dmxJ7 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BasePopup-module__primary-border-r___lO6kO {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BasePopup-module__secondary-border____DWks {
  border: 1px solid #637768;
}

.BasePopup-module__secondary-border-b___VhABY {
  border-bottom: 1px solid #637768;
}

.BasePopup-module__secondary-border-t___J6Odn {
  border-top: 1px solid #637768;
}

.BasePopup-module__secondary-border-l___G2MDQ {
  border-left: 1px solid #637768;
}

.BasePopup-module__secondary-border-r___wAnLy {
  border-right: 1px solid #637768;
}

.BasePopup-module__gap-0___zjYiO {
  gap: 0 !important;
}

.BasePopup-module__gap-2___UIyi8 {
  gap: 2px !important;
}

.BasePopup-module__gap-4___kNr3g {
  gap: 4px !important;
}

.BasePopup-module__gap-5___nHLg1 {
  gap: 5px !important;
}

.BasePopup-module__gap-6___n9dx1 {
  gap: 6px !important;
}

.BasePopup-module__gap-8___bStQX {
  gap: 8px !important;
}

.BasePopup-module__gap-10___U68WR {
  gap: 10px !important;
}

.BasePopup-module__gap-12___RbHGo {
  gap: 12px !important;
}

.BasePopup-module__gap-14___TRjJQ {
  gap: 14px !important;
}

.BasePopup-module__gap-16___rtXmn {
  gap: 16px !important;
}

.BasePopup-module__gap-18___q04W1 {
  gap: 18px !important;
}

.BasePopup-module__gap-20___PlNXC {
  gap: 20px !important;
}

.BasePopup-module__gap-24___D0hUP {
  gap: 24px !important;
}

.BasePopup-module__gap-26___yFQJc {
  gap: 26px !important;
}

.BasePopup-module__gap-30___flsNO {
  gap: 30px !important;
}

.BasePopup-module__gap-32___X0SSW {
  gap: 32px !important;
}

.BasePopup-module__gap-40___q5uHy {
  gap: 40px !important;
}

.BasePopup-module__gap-50___fltRE {
  gap: 50px !important;
}

.BasePopup-module__flex-1___f626F {
  flex: 1;
}

.BasePopup-module__flex-none___bFs_F {
  flex: none !important;
}

.BasePopup-module__flex-column___Fzyv1 {
  display: flex;
  flex-direction: column !important;
}

.BasePopup-module__flex-row___V_GkK {
  display: flex;
  flex-direction: row !important;
}

.BasePopup-module__vertically-centered___snrQW {
  display: flex;
  align-items: center !important;
}

.BasePopup-module__horizontally-centered___L5fKh {
  display: flex;
  justify-content: center !important;
}

.BasePopup-module__horizontally-end___rtYYD {
  display: flex;
  justify-content: end !important;
}

.BasePopup-module__vertically-start___whjnO {
  display: flex;
  align-items: start !important;
}

.BasePopup-module__space-between___wF4xp {
  display: flex;
  justify-content: space-between !important;
}

.BasePopup-module__flex-wrap___ECzzz {
  flex-wrap: wrap !important;
}

.BasePopup-module__height-100___KxhlB {
  height: 100%;
}

.BasePopup-module__width-50___HlM9r {
  width: 50% !important;
}

.BasePopup-module__width-100___aTkW6 {
  width: 100%;
}

.BasePopup-module__cursor-pointer___V6FxG {
  cursor: pointer;
}

.BasePopup-module__cursor-not-allowed___GYink {
  cursor: not-allowed !important;
}

.BasePopup-module__absolute-centered___jDLsy {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BasePopup-module__absolute___Ppqe9 {
  position: absolute;
}

.BasePopup-module__relative___o1XBL {
  position: relative;
}

.BasePopup-module__fixed___guBZO {
  position: fixed;
}

.BasePopup-module__visible___ARqqW {
  opacity: 1;
}

.BasePopup-module__invisible___e0Pvx {
  opacity: 0;
}

.BasePopup-module__col-90___PfHyP {
  width: 90% !important;
}

.BasePopup-module__col-auto___k27ZZ {
  width: auto !important;
}

.BasePopup-module__medical-tabs___aIKF3 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BasePopup-module__medical-table-new___Bfx9d {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BasePopup-module__medical-table-new___Bfx9d:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BasePopup-module__medical-table-new___Bfx9d::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BasePopup-module__medical-table-new___Bfx9d::-webkit-scrollbar-track {
  display: none;
}
.BasePopup-module__medical-table-new___Bfx9d.BasePopup-module__no-pagination___OuZO9 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BasePopup-module__medical-table-new___Bfx9d.BasePopup-module__no-pagination___OuZO9:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BasePopup-module__medical-table-new___Bfx9d.BasePopup-module__no-pagination___OuZO9::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BasePopup-module__medical-table-new___Bfx9d.BasePopup-module__no-pagination___OuZO9::-webkit-scrollbar-track {
  display: none;
}

.BasePopup-module__medical-table-empty___mbnOy {
  padding: 14px 40px !important;
}

.BasePopup-module__icon-btn___ndIkX {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BasePopup-module__search-icon___Uczno {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BasePopup-module__disable-select___OPDm5 {
  user-select: none;
}

.BasePopup-module__break-word___GuRcg {
  word-break: break-word;
}

.BasePopup-module__popup-clear-btn___YRo04 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BasePopup-module__scroll-m-b-20___CzGnZ {
  scroll-margin-bottom: 20px;
}

.BasePopup-module__container___SIbz1 {
  justify-content: center;
  overflow: hidden;
}
.BasePopup-module__container___SIbz1 .BasePopup-module__titleContainer___oK0uw {
  padding: 17px 30px;
}
.BasePopup-module__container___SIbz1 .BasePopup-module__titleContainer___oK0uw .BasePopup-module__title___KhnyX {
  color: #375844;
  line-height: 27px;
}
.BasePopup-module__container___SIbz1 .BasePopup-module__titleContainer___oK0uw .BasePopup-module__subtitle___sKQhw {
  color: #859989;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/BasePopup/BasePopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,uBAAA;EACA,gBAAA;AA8pBF;AA5pBE;EACE,kBAAA;AA8pBJ;AA5pBI;EACE,cAAA;EACA,iBAAA;AA8pBN;AA3pBI;EACE,cAAA;AA6pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  justify-content: center;\n  overflow: hidden;\n\n  .titleContainer {\n    padding: 17px 30px;\n\n    .title {\n      color: get-color(greenNew, dark);\n      line-height: 27px;\n    }\n\n    .subtitle {\n      color: get-color(greenNew, medium);\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BasePopup-module__font-s-10___z6vHk`,
	"fontS12": `BasePopup-module__font-s-12___AECVr`,
	"fontS13": `BasePopup-module__font-s-13___jD4Xc`,
	"fontS14": `BasePopup-module__font-s-14___uYASq`,
	"fontS15": `BasePopup-module__font-s-15___o_hF6`,
	"fontS16": `BasePopup-module__font-s-16___Y6dAM`,
	"fontS18": `BasePopup-module__font-s-18___EzuRL`,
	"fontS20": `BasePopup-module__font-s-20___szNU4`,
	"fontS22": `BasePopup-module__font-s-22____UxZT`,
	"fontS28": `BasePopup-module__font-s-28___m8Zbj`,
	"fontW400": `BasePopup-module__font-w-400___K7Xox`,
	"fontW500": `BasePopup-module__font-w-500___xJAwv`,
	"fontW600": `BasePopup-module__font-w-600___ug90o`,
	"fontW700": `BasePopup-module__font-w-700___sT_T1`,
	"p5": `BasePopup-module__p-5___jt0Hh`,
	"p12": `BasePopup-module__p-12___FLkgo`,
	"p16": `BasePopup-module__p-16___o3nkw`,
	"p30": `BasePopup-module__p-30___XHbQR`,
	"pB0": `BasePopup-module__p-b-0___iINuq`,
	"pB5": `BasePopup-module__p-b-5___Ul_C_`,
	"pB10": `BasePopup-module__p-b-10___zXuAM`,
	"pB12": `BasePopup-module__p-b-12___fuH9l`,
	"pB16": `BasePopup-module__p-b-16___KR4YZ`,
	"pB18": `BasePopup-module__p-b-18____Y3lu`,
	"pB20": `BasePopup-module__p-b-20___RGy7_`,
	"pB25": `BasePopup-module__p-b-25___PhhJM`,
	"pB30": `BasePopup-module__p-b-30___NQk7g`,
	"pB50": `BasePopup-module__p-b-50___SJ65S`,
	"pT0": `BasePopup-module__p-t-0___sfizd`,
	"pT12": `BasePopup-module__p-t-12___jvOgT`,
	"pT16": `BasePopup-module__p-t-16___WMsKd`,
	"pT18": `BasePopup-module__p-t-18___kp4V4`,
	"pT20": `BasePopup-module__p-t-20___yqekv`,
	"pT30": `BasePopup-module__p-t-30___Va2_j`,
	"pT40": `BasePopup-module__p-t-40___OHpaF`,
	"pT50": `BasePopup-module__p-t-50___ySCrN`,
	"pL20": `BasePopup-module__p-l-20___I4MmB`,
	"pL30": `BasePopup-module__p-l-30___wAPrD`,
	"pL40": `BasePopup-module__p-l-40___tCBaV`,
	"pR16": `BasePopup-module__p-r-16___S_QWH`,
	"pR20": `BasePopup-module__p-r-20___kgrIe`,
	"pR30": `BasePopup-module__p-r-30___c379q`,
	"pR50": `BasePopup-module__p-r-50___p8_9x`,
	"pR60": `BasePopup-module__p-r-60___Xv88m`,
	"mB1": `BasePopup-module__m-b-1___bQVcg`,
	"mB2": `BasePopup-module__m-b-2___Xoyf7`,
	"mB6": `BasePopup-module__m-b-6___EWEqD`,
	"mB8": `BasePopup-module__m-b-8___L7BpU`,
	"mB10": `BasePopup-module__m-b-10___cnGmf`,
	"mB14": `BasePopup-module__m-b-14___z6rEl`,
	"mB16": `BasePopup-module__m-b-16___bJxG3`,
	"mB20": `BasePopup-module__m-b-20___lXHsS`,
	"mB22": `BasePopup-module__m-b-22___iGZfV`,
	"mB24": `BasePopup-module__m-b-24___tA6tv`,
	"mB30": `BasePopup-module__m-b-30___U7U5O`,
	"mB32": `BasePopup-module__m-b-32___p3E31`,
	"mB40": `BasePopup-module__m-b-40___j2ZRF`,
	"mT2": `BasePopup-module__m-t-2___g2R2g`,
	"mT3": `BasePopup-module__m-t-3___QePtk`,
	"mT4": `BasePopup-module__m-t-4___qHfSO`,
	"mT5": `BasePopup-module__m-t-5___rbDcF`,
	"mT8": `BasePopup-module__m-t-8___rhwtV`,
	"mT10": `BasePopup-module__m-t-10___EWRzH`,
	"mT15": `BasePopup-module__m-t-15___VT30O`,
	"mT16": `BasePopup-module__m-t-16____VimJ`,
	"mT20": `BasePopup-module__m-t-20___atkAu`,
	"mT22": `BasePopup-module__m-t-22___NU_Pp`,
	"mT30": `BasePopup-module__m-t-30___lnqbS`,
	"mT32": `BasePopup-module__m-t-32___INfLx`,
	"mLAuto": `BasePopup-module__m-l-auto___hyG6t`,
	"mL4": `BasePopup-module__m-l-4___uiJe3`,
	"mL5": `BasePopup-module__m-l-5___K2sDK`,
	"mL6": `BasePopup-module__m-l-6___Q4s1K`,
	"mL8": `BasePopup-module__m-l-8___R18X2`,
	"mL10": `BasePopup-module__m-l-10___G4qvA`,
	"mL16": `BasePopup-module__m-l-16___J7YGB`,
	"mL20": `BasePopup-module__m-l-20____8erd`,
	"mL24": `BasePopup-module__m-l-24___vIuRW`,
	"mL30": `BasePopup-module__m-l-30___bM5wq`,
	"mL35": `BasePopup-module__m-l-35___mOT8J`,
	"mL40": `BasePopup-module__m-l-40___qPepu`,
	"mR8": `BasePopup-module__m-r-8___mJ95N`,
	"mR10": `BasePopup-module__m-r-10___Ewj91`,
	"mR16": `BasePopup-module__m-r-16___EWai_`,
	"mR20": `BasePopup-module__m-r-20___Kolph`,
	"mR24": `BasePopup-module__m-r-24___Ki0gN`,
	"mR30": `BasePopup-module__m-r-30___orBcb`,
	"mR40": `BasePopup-module__m-r-40___nvK7V`,
	"borderR3": `BasePopup-module__border-r-3___uXoxK`,
	"borderR4": `BasePopup-module__border-r-4___eNf1X`,
	"borderR6": `BasePopup-module__border-r-6___vasEC`,
	"borderR10": `BasePopup-module__border-r-10___I9cAv`,
	"borderR12": `BasePopup-module__border-r-12___PAJLb`,
	"borderR16": `BasePopup-module__border-r-16___siVbK`,
	"borderR50": `BasePopup-module__border-r-50___crWkF`,
	"primaryBorder": `BasePopup-module__primary-border___MLeVz`,
	"primaryBorderB": `BasePopup-module__primary-border-b___BytEe`,
	"primaryBorderT": `BasePopup-module__primary-border-t___iuZjx`,
	"primaryBorderL": `BasePopup-module__primary-border-l___dmxJ7`,
	"primaryBorderR": `BasePopup-module__primary-border-r___lO6kO`,
	"secondaryBorder": `BasePopup-module__secondary-border____DWks`,
	"secondaryBorderB": `BasePopup-module__secondary-border-b___VhABY`,
	"secondaryBorderT": `BasePopup-module__secondary-border-t___J6Odn`,
	"secondaryBorderL": `BasePopup-module__secondary-border-l___G2MDQ`,
	"secondaryBorderR": `BasePopup-module__secondary-border-r___wAnLy`,
	"gap0": `BasePopup-module__gap-0___zjYiO`,
	"gap2": `BasePopup-module__gap-2___UIyi8`,
	"gap4": `BasePopup-module__gap-4___kNr3g`,
	"gap5": `BasePopup-module__gap-5___nHLg1`,
	"gap6": `BasePopup-module__gap-6___n9dx1`,
	"gap8": `BasePopup-module__gap-8___bStQX`,
	"gap10": `BasePopup-module__gap-10___U68WR`,
	"gap12": `BasePopup-module__gap-12___RbHGo`,
	"gap14": `BasePopup-module__gap-14___TRjJQ`,
	"gap16": `BasePopup-module__gap-16___rtXmn`,
	"gap18": `BasePopup-module__gap-18___q04W1`,
	"gap20": `BasePopup-module__gap-20___PlNXC`,
	"gap24": `BasePopup-module__gap-24___D0hUP`,
	"gap26": `BasePopup-module__gap-26___yFQJc`,
	"gap30": `BasePopup-module__gap-30___flsNO`,
	"gap32": `BasePopup-module__gap-32___X0SSW`,
	"gap40": `BasePopup-module__gap-40___q5uHy`,
	"gap50": `BasePopup-module__gap-50___fltRE`,
	"flex1": `BasePopup-module__flex-1___f626F`,
	"flexNone": `BasePopup-module__flex-none___bFs_F`,
	"flexColumn": `BasePopup-module__flex-column___Fzyv1`,
	"flexRow": `BasePopup-module__flex-row___V_GkK`,
	"verticallyCentered": `BasePopup-module__vertically-centered___snrQW`,
	"horizontallyCentered": `BasePopup-module__horizontally-centered___L5fKh`,
	"horizontallyEnd": `BasePopup-module__horizontally-end___rtYYD`,
	"verticallyStart": `BasePopup-module__vertically-start___whjnO`,
	"spaceBetween": `BasePopup-module__space-between___wF4xp`,
	"flexWrap": `BasePopup-module__flex-wrap___ECzzz`,
	"height100": `BasePopup-module__height-100___KxhlB`,
	"width50": `BasePopup-module__width-50___HlM9r`,
	"width100": `BasePopup-module__width-100___aTkW6`,
	"cursorPointer": `BasePopup-module__cursor-pointer___V6FxG`,
	"cursorNotAllowed": `BasePopup-module__cursor-not-allowed___GYink`,
	"absoluteCentered": `BasePopup-module__absolute-centered___jDLsy`,
	"absolute": `BasePopup-module__absolute___Ppqe9`,
	"relative": `BasePopup-module__relative___o1XBL`,
	"fixed": `BasePopup-module__fixed___guBZO`,
	"visible": `BasePopup-module__visible___ARqqW`,
	"invisible": `BasePopup-module__invisible___e0Pvx`,
	"col90": `BasePopup-module__col-90___PfHyP`,
	"colAuto": `BasePopup-module__col-auto___k27ZZ`,
	"medicalTabs": `BasePopup-module__medical-tabs___aIKF3`,
	"medicalTableNew": `BasePopup-module__medical-table-new___Bfx9d`,
	"noPagination": `BasePopup-module__no-pagination___OuZO9`,
	"medicalTableEmpty": `BasePopup-module__medical-table-empty___mbnOy`,
	"iconBtn": `BasePopup-module__icon-btn___ndIkX`,
	"searchIcon": `BasePopup-module__search-icon___Uczno`,
	"disableSelect": `BasePopup-module__disable-select___OPDm5`,
	"breakWord": `BasePopup-module__break-word___GuRcg`,
	"popupClearBtn": `BasePopup-module__popup-clear-btn___YRo04`,
	"scrollMB20": `BasePopup-module__scroll-m-b-20___CzGnZ`,
	"container": `BasePopup-module__container___SIbz1`,
	"titleContainer": `BasePopup-module__titleContainer___oK0uw`,
	"title": `BasePopup-module__title___KhnyX`,
	"subtitle": `BasePopup-module__subtitle___sKQhw`
};
module.exports = ___CSS_LOADER_EXPORT___;
